module.exports = angular.module('msi.layout', [
  require('@ordergroove/brandy/src/app/shipments'),
  require('@ordergroove/brandy/src/app/paymetric'),
  require('@ordergroove/brandy/src/app/tracking'),
  require('./states'),
  require('./forbidden'),
  require('./logged-out'),
  require('./config/config')
]).name;


require('./controllers/layout.controller');
